module.exports = "/_next/static/images/manifest-d289618790429d962d1669e1b4136c64.png";